import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
// import AddProductForm from './form/addForm';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getCategory } from '../categories/_api';
import { get, find, filter } from 'lodash';
import { attributeValueGet } from '../app/_api';
import AddAttributeToProductForm from './form/attributeForm';
import { addAttributeProductValue, getProduct, addItem, updateProduct } from './_api';
import { Grid, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { SortingState, IntegratedSorting } from '@devexpress/dx-react-grid';
import Button from '@material-ui/core/Button';
import AddItemForm from './form/addItemForm';
import { withSnackbar } from 'notistack';
import { times, includes } from 'lodash';
import { itemStatus } from '../../utils/constants';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding: 10,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withState('expanded', 'setExpanded', { info: false, attr: false, items: true }),
  withState('category', 'setCategory', null),
  withState('product', 'setProduct', null),
  withState('add', 'setAdd', false),
  withProps(({ product }) => {
    let initialAttributes = [];
    get(product, 'attributes', []).map((item) => {
      initialAttributes[item.attributeId] = item.id;
      return '';
    });
    return { initialAttributes };
  }),
  withProps(
    ({
      product,
      match: {
        params: { id },
      },
    }) => {
      let columns = [
        { name: 'price', title: 'Cena' },
        { name: 'serialNumber', title: 'Sériové číslo' },
        {
          name: 'status',
          title: 'Stav',
          getCellValue: (row) => get(find(itemStatus, { id: row.status }), 'label'),
        },
      ];
      if (get(product, 'categoryId', false) === 'LYZE') {
        columns.push({
          name: 'serialNumber2',
          title: 'Kategorie lyží',
          getCellValue: (row) =>
            get(find(get(row, 'attributes', []), { name: 'Kategorie lyží' }), 'value', null),
        });
      }
      return {
        productId: id,
        columns,
      };
    }
  ),
  lifecycle({
    async componentDidMount() {
      const { productId, toggleLoader, setProduct, setCategory } = this.props;
      toggleLoader();
      const resp = await getProduct(productId);
      if (resp) {
        setProduct(resp);
        const resp2 = await getCategory(resp.categoryId);
        if (resp2) {
          Promise.all(
            get(resp2, 'attributes', []).map(async (item) => {
              const values = await attributeValueGet(item.id);
              return { ...item, values: values.items };
            })
          ).then((values) => setCategory(filter(values, (item) => includes([1, 2], item.level))));
        }
      }
      toggleLoader(false);
    },
    async componentWillReceiveProps(nextProps) {
      const { setProduct, productId, toggleLoader } = this.props;
      toggleLoader();
      if (this.props.reload !== nextProps.reload) {
        const resp = await getProduct(productId);
        if (resp) {
          setProduct(resp);
        }
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    redirectTo:
      ({ history, productId }) =>
      async (id) => {
        history.push(`/products/${productId}/items/${id}`);
      },
  }),
  withHandlers({
    TableRow:
      ({ redirectTo }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
            }}
            onClick={() => redirectTo(get(row, 'id'))}
          />
        ),
  }),
  withHandlers({
    onSubmitInfo:
      ({ product, setProduct, enqueueSnackbar, toggleLoader }) =>
      async (values) => {
        toggleLoader();
        const resp = await updateProduct(values);
        if (get(resp, 'success', false)) {
          enqueueSnackbar('Produkt byl úspěšně změněn.', { variant: 'success' });
          setProduct(resp.data);
        } else {
          enqueueSnackbar('Produkt se nepodařilo změnit.', { variant: 'error' });
        }
        toggleLoader(false);
      },
    handleExpansionChange:
      ({ expanded, setExpanded }) =>
      (part, value) => {
        setExpanded({ ...expanded, [part]: !value });
      },
    onSubmitAttrs:
      ({ product, history, toggleLoader, enqueueSnackbar }) =>
      async (values) => {
        toggleLoader();
        const resp = await addAttributeProductValue(product.id, values.attributes);
        if (get(resp, 'success', false)) {
          enqueueSnackbar('Atributy byly uloženy.', { variant: 'success' });
        } else {
          enqueueSnackbar('Atributy nepodařilo uložit.', { variant: 'error' });
        }
        toggleLoader(false);
      },
    onSubmitItem:
      ({ productId, setAdd, setProduct, toggleLoader }) =>
      async (values) => {
        toggleLoader();
        await times(get(values, 'count', 1), async (i) => {
          const resp = await addItem(productId, values);
          if (resp) {
            setAdd(false);
            const resp2 = await getProduct(productId);
            if (resp2) {
              setProduct(resp2);
            }
          }
        });
        toggleLoader(false);
      },
  })
);

export default enhance(
  ({
    classes,
    onSubmitInfo,
    onSubmitAttrs,
    handleExpansionChange,
    expanded,
    product,
    category,
    initialAttributes,
    add,
    setAdd,
    onSubmitItem,
    TableRow,
    setDialog,
    columns,
  }) => (
    <div className={classes.root}>
      <h3>Detail produktu</h3>
      <Paper className={classes.paper}>
        {/* <ExpansionPanel
          expanded={expanded.info}
          onChange={() => handleExpansionChange('info', expanded.info)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Základní informace</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              {product && (
                <AddProductForm
                  add={false}
                  onSubmit={onSubmitInfo}
                  initialValues={{
                    name: get(product, 'name', ''),
                    description: get(product, 'description', ''),
                    categoryId: get(product, 'categoryId', ''),
                    id: get(product, 'id', ''),
                  }}
                />
              )}
            </div>
          </ExpansionPanelDetails>
                </ExpansionPanel>*/}
        <ExpansionPanel
          expanded={expanded.attr}
          onChange={() => handleExpansionChange('attr', expanded.attr)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Atributy</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {product && category ? (
              <AddAttributeToProductForm
                onSubmit={onSubmitAttrs}
                category={category}
                initialValues={{ attributes: initialAttributes }}
              />
            ) : (
              ' '
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel
          expanded={expanded.items}
          onChange={() => handleExpansionChange('items', expanded.items)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Položky</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              {!add ? (
                <Button variant="contained" color="primary" onClick={() => setAdd(true)}>
                  Přidat
                </Button>
              ) : (
                <AddItemForm onSubmit={onSubmitItem} setAdd={setAdd} add={true} />
              )}
              <div className="grid--clickable grid--custom">
                <Grid
                  rows={get(product, 'items', [])}
                  columns={[
                    ...columns,
                    {
                      name: 'delete',
                      title: ' ',
                      getCellValue: (row) => (
                        <div>
                          <Button
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDialog({ open: true, id: row.id, action: 'item-delete' });
                            }}
                          >
                            Smazat
                          </Button>
                        </div>
                      ),
                    },
                  ]}
                >
                  <SortingState defaultSorting={[{ columnName: 'price', direction: 'asc' }]} />
                  <IntegratedSorting />
                  <Table rowComponent={TableRow} />
                  <TableHeaderRow showSortingControls />
                </Grid>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Paper>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/products/detail.js